import { END_RULES_COMBINE, END_RULE_TYPE } from 'features/schedulingEngine/constants'
import { resolveEngineAnchorStudyDay } from './anchorStudyDay'

export const getEngineEndRules = schedule => schedule?.end_rules?.rules || []

export const getAfterNOccurrencesEndRuleCount = schedule => {
  const rule = getEngineEndRules(schedule).find(
    r => r?.type === END_RULE_TYPE.afterNOccurrences || r?.type === 'after_n_occurrences',
  )
  const count = rule?.count ?? rule?.recurrences
  if (count == null || count <= 0) return null
  return Math.floor(Number(count))
}

const isRelativeToVisitEndRule = rule =>
  rule?.type === END_RULE_TYPE.relativeToVisit || rule?.type === 'relative_to_visit'

const resolveRelativeToVisitEndStudyDay = (rule, context) => {
  const byArm = rule.by_arm || rule.byArm || {}
  const anchorContext = {
    ...context,
    arms: context.arms || context.armsForEngine || [],
  }
  const point = rule.point || 'completed'
  const days = []

  Object.entries(byArm).forEach(([armId, entry]) => {
    const visitId = entry?.visit_id ?? entry?.visitId
    if (visitId == null || visitId === '') return
    const day = resolveEngineAnchorStudyDay(
      {
        type: 'visit',
        point,
        visits: [{ visit_id: visitId, arm_id: armId }],
        offset: rule.offset,
      },
      anchorContext,
    )
    if (day != null) days.push(day)
  })

  if (!days.length) return null
  return Math.min(...days)
}

/** Last study day the series may surface (from V3 end_rules), or null when unknown. */
export const resolveEndRulesLastStudyDay = (schedule, context = {}) => {
  const endRules = schedule?.end_rules
  const rules = getEngineEndRules(schedule).filter(rule => rule?.type)
  if (!rules.length) return null

  const combine = endRules?.combine || END_RULES_COMBINE.earliestOf
  const relativeDays = rules
    .filter(isRelativeToVisitEndRule)
    .map(rule => resolveRelativeToVisitEndStudyDay(rule, context))
    .filter(day => day != null)

  if (!relativeDays.length) return null
  if (combine === END_RULES_COMBINE.latestOf) return Math.max(...relativeDays)
  return Math.min(...relativeDays)
}
